import { customerPortal } from "@vilocnv/allsetra-core";
import { createSlice } from "@reduxjs/toolkit";
import getGeozonesCases from "./cases/get-geozones.cases";
import getGeozoneByIdCases from "./cases/get-geozone-by-id.cases";
import getGeozoneObjectsCases from "./cases/get-geozone-objects.cases";
import postGeozoneCases from "./cases/post-geozone.cases";
import getGeozoneAssignedObjectsCases from "./cases/get-geozone-assigned-objects.cases";
import patchGeozoneCases from "./cases/patch-geozone.cases";

type GeozonesState = customerPortal.geozones.GeozonesState;

const initialState: GeozonesState = {
  geozones: [],
  isLoadingGeozones: false,
  selectedGeozone: undefined,
  isLoadingSelectedGeozone: false,
  geozoneObjects: [],
  isLoadingGeozoneObjects: false,
  geozoneObjectsMarkers: [],
  geozoneAssignedObjects: [],
  isLoadingGeozoneAssignedObjects: false,
  geozoneAssignedObjectsMarkers: []
};

const geozonesSlice = createSlice({
  name: "geozones/v2",
  initialState,
  reducers: {
    clearSelectedGeozone: (state) => {
      state.selectedGeozone = undefined;
    }
  },
  extraReducers: (builder) => {
    getGeozonesCases(builder);
    getGeozoneByIdCases(builder);
    getGeozoneObjectsCases(builder);
    postGeozoneCases(builder);
    getGeozoneAssignedObjectsCases(builder);
    patchGeozoneCases(builder);
  }
});

export default geozonesSlice.reducer;

export const { clearSelectedGeozone } = geozonesSlice.actions;
